import { redirectIfNotAuthenticated } from '../actions/user';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showAppLoaderSelector, userIdSelector } from '../helpers/selectors';
import { Outlet } from 'react-router-dom';

export default function Authenticated({ location }) {
  const dispatch = useDispatch();
  const userId = useSelector(userIdSelector);
  const showAppLoader = useSelector(showAppLoaderSelector);

  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    console.log('[KC-DEBUG] Authenticated.js/useEffect: DECISION - wait for loader, then userId gate (no userId => redirectIfNotAuthenticated => login popup)', { showAppLoader, waitingForSsoCheck: showAppLoader, userId, hasUserId: Boolean(userId), redirected, pathname: location?.pathname }); // eslint-disable-line no-console
    // Wait for the Keycloak SSO session check (silent check-sso) to settle before
    // deciding the user is unauthenticated, otherwise a hard refresh would redirect
    // to the login popup before the session is restored.
    if (showAppLoader) {
      console.log('[KC-DEBUG] Authenticated.js/useEffect: WAITING - showAppLoader is still true, the auth decision is deferred to a later effect run', { showAppLoader, userId, pathname: location?.pathname }); // eslint-disable-line no-console
      return;
    }

    if (userId) {
      console.log('[KC-DEBUG] Authenticated.js/useEffect: userId present => rendering the protected route', { userId, redirected, pathname: location?.pathname }); // eslint-disable-line no-console
      setRedirected(false);
    } else if (!redirected) {
      console.log('[KC-DEBUG] Authenticated.js/useEffect: NO userId after the loader settled => redirectIfNotAuthenticated (this is what the user sees when the KC restore silently failed)', { userId, redirected, pathname: location?.pathname, atIso: new Date().toISOString(), perfNowMs: Math.round(performance.now()) }); // eslint-disable-line no-console
      setRedirected(true);
      dispatch(redirectIfNotAuthenticated(location));
    } else {
      console.log('[KC-DEBUG] Authenticated.js/useEffect: NO userId but already redirected once => doing nothing', { userId, redirected, pathname: location?.pathname }); // eslint-disable-line no-console
    }
  }, [userId, location, showAppLoader]);

  if (userId) return <Outlet />;
  return null;
}
